import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from './redux-hooks';
import { setLocale, setShowLanguageSwitcher } from '../../store/redux/menuSlice';
import { SOURCE_LOCALE, supportedLocalesOf } from '../localization/apply';
import { resolveInitialLocale } from '../localization/languages';

export function useMenuLocaleInit(): void {
    const dispatch = useAppDispatch();
    const menu = useAppSelector((state) => state.menu.menu);

    useEffect(() => {
        if (!menu) return;
        const languageEnabled = menu.featureLanguage === true;
        const supported = languageEnabled ? supportedLocalesOf(menu) : [];
        dispatch(
            setLocale(languageEnabled ? resolveInitialLocale(menu.id, supported) : SOURCE_LOCALE)
        );
        dispatch(setShowLanguageSwitcher(languageEnabled && supported.length > 0));
    }, [menu?.id, menu?.featureLanguage, dispatch]);
}
